import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractCommissionConcept } from '../../../models/Entities/Contracts/ContractCommissionConcept';

export default function ContractCommissionConceptsReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;

  switch (a.type) {
    case 'CONTRACT_COMMISSION_CONCEPT_GET_ALL_SUCCESS': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (contract) {
        contract.commissionConcepts = a.contractCommissionConcepts as ContractCommissionConcept[];
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_CONCEPT_UPDATE_SUCCESS': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractCommissionConcept.contractId);
      if (contract) {
        contract.commissionConcepts = [
          ...((contract.commissionConcepts || []).filter((item: ContractCommissionConcept) => item.id !== a.contractCommissionConcept.id)),
          a.contractCommissionConcept,
        ];
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_CONCEPT_CREATE_SUCCESS': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractCommissionConcept.contractId);
      if (contract) {
        contract.commissionConcepts = [...(contract.commissionConcepts || []), a.contractCommissionConcept];
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    case 'CONTRACT_COMMISSION_CONCEPT_DELETE_SUCCESS': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (contract) {
        contract.commissionConcepts = (contract.commissionConcepts || []).filter(
          (item: ContractCommissionConcept) => item.id !== a.contractCommissionConceptId
        );
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    default:
      return currentState;
  }
}
